import { useRoutes } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import { getLayoutForPath, publicPaths, routeObjects } from "./routes";

// Main routing hook
export function useAppRoutes() {
  return useRoutes(routeObjects);
}

// Export utilities
export { getLayoutForPath, publicPaths };

// Re-export ProtectedRoute for convenience
  export { ProtectedRoute };
